import {
    JournalEntryLineProxyObject,
    NUMBER_OF_CELLS_PER_LINE,
} from "../journalEntryModal/JournalEntryModal";
import { SharedTableHeader } from "./SharedTableHeader";

interface Props {
    isEditable?: boolean;
}

export const EditableTableHeader: React.FC<Props> = ({ isEditable }) => (
    <SharedTableHeader<JournalEntryLineProxyObject>
        isEditable={isEditable}
        numberOfCellsPerLine={NUMBER_OF_CELLS_PER_LINE}
        columns={["Account", "Debit", "Credit", "Description"]}
        editableGridCols="40fr 429fr 122fr 122fr 434fr 60fr"
    />
);
